// DwsIcon's inline SVG: fetches the file in the browser and hands large ones over as a stream.

import { publish } from "../shared/publish";

// DwsIcon (DwsIconType.Svg with InlineSvg): the text of an SVG file, which the component sanitises (DwsSvgSanitizer)
// and places inline. Fetched by the browser, so a relative URL, cookies and CORS behave as they do for any other
// request of the page - the same in Blazor Server and WebAssembly. Null (the component then shows the file through
// <object>) when it cannot be read: not found, cross-origin without CORS, not an SVG, or larger than maxBytes as the
// JSON that carries it back to .NET (one SignalR message on Blazor Server) - unless streamLarger is true: the text is
// then kept here and 'dws-svg-stream:<bytes>' is returned, and the component fetches it with dwsIconTakeLargeSvg as a
// stream, which is transferred in chunks.
/** SVG text too large for one interop message, by URL, until DwsIcon streams it with dwsIconTakeLargeSvg. */
const dwsIconLargeSvg: Record<string, Blob> = {};
publish("dwsIconLargeSvg", dwsIconLargeSvg);

publish("dwsIconTakeLargeSvg", function (url: string): Blob {
    let blob = window.dwsIconLargeSvg[url];

    delete window.dwsIconLargeSvg[url];

    if (!blob) {
        throw new Error('No SVG is waiting for ' + url);
    }

    return blob;
});

publish("dwsIconFetchSvg", function (url: string, maxBytes: number, streamLarger?: boolean): Promise<string | null> {
    if (typeof url !== 'string' || url.length === 0 || typeof window.fetch !== 'function') {
        return Promise.resolve(null);
    }

    return window.fetch(url, { credentials: 'same-origin' }).then(function (response) {
        return response.ok ? response.text() : null;
    }).then(function (text) {
        if (typeof text !== 'string' || text.indexOf('<svg') < 0) {
            return null;
        }

        if (maxBytes > 0 && new TextEncoder().encode(JSON.stringify(text)).length > maxBytes) {
            // 512000: the sanitiser's limit - a longer file would be refused there anyway.
            if (streamLarger !== true || text.length > 512000 || typeof Blob !== 'function') {
                return null;
            }

            let blob = new Blob([text], { type: 'image/svg+xml' });

            window.dwsIconLargeSvg[url] = blob;

            return 'dws-svg-stream:' + blob.size;
        }

        return text;
    }).catch(function () {
        return null;
    });
});
